/**
 * O que vai no subtítulo de cada lançamento nas listas, antes da conta ("Moradia · Itaú").
 *
 * - `category`: só a categoria (padrão, comportamento histórico).
 * - `subcategory`: só a subcategoria — o ícone da linha já diz a categoria.
 * - `both`: as duas, no mesmo formato do formulário ("Moradia › Celular").
 *
 * Pedido de usuário (Denis, migrante do Organizze): a subcategoria só aparecia abrindo o
 * lançamento.
 */
export type StatementCategoryLabel = 'category' | 'subcategory' | 'both';

export const DEFAULT_STATEMENT_CATEGORY_LABEL: StatementCategoryLabel = 'category';

/**
 * Sem subcategoria, qualquer modo cai na categoria — "só subcategoria" não pode deixar a
 * linha sem rótulo. Modo desconhecido (preferência corrompida, mock de teste) vale como o
 * padrão.
 */
export function formatStatementCategoryLabel(
    mode: StatementCategoryLabel | undefined,
    categoryName: string | null | undefined,
    subcategoryName: string | null | undefined,
): string | null {
    const category = categoryName || null;
    const subcategory = subcategoryName || null;

    switch (mode) {
        case 'subcategory':
            return subcategory ?? category;
        case 'both':
            return category && subcategory ? `${category} › ${subcategory}` : (category ?? subcategory);
        default:
            return category;
    }
}
